<template>
  <Dialog
    :id="uniqueid"
    :titulo="'Source - ' + (source.nome || source.hostname || '')"
    ref="dialog"
    :modal="true"
    :hideFooter="true"
    :tamanho="'lg'"
  >
    <div>
      <div class="d-flex justify-content-between" style="margin-bottom: 10px">
        <div class="text-left">
          <h6 style="margin-bottom: 0px">
            {{ source.nome || source.hostname || "Source" }}
          </h6>
          <small class="text-secondary">{{ source.key || "-" }}</small>
        </div>
        <span
          class="badge"
          style="height: 22px"
          v-bind:class="{
            'badge-success': connected,
            'badge-secondary': !connected,
          }"
        >
          {{ connected ? "Conectado" : "Offline" }}
        </span>
      </div>

      <div class="text-left">
        <label><small>Dispositivo de video</small></label>
        <select class="form-control" v-model="deviceId" @change="aplicarAudioVinculado">
          <option value="">Selecione...</option>
          <option
            v-for="device in videoDevices"
            :key="device.id + '_' + device.label"
            :value="device.id"
          >
            {{ device.label || device.id }}
          </option>
        </select>
      </div>

      <div class="text-left" style="margin-top: 10px">
        <label><small>Dispositivo de audio</small></label>
        <select class="form-control" v-model="audioId" @change="onAudioChange">
          <option value="">Sem audio</option>
          <option
            v-for="device in selectableAudioDevices"
            :key="device.id + '_' + device.label"
            :value="device.id"
          >
            {{ device.label || device.id }}
          </option>
        </select>
      </div>

      <div class="alert alert-light text-center" style="margin-top: 12px; margin-bottom: 8px">
        <small>{{ mensagem || 'Clique em &quot;Ver video&quot; para iniciar.' }}</small>
      </div>

      <div class="text-center">
        <button
          type="button"
          class="btn btn-primary btn-sm"
          @click="iniciarPreview()"
          :disabled="!connected || deviceId == '' || loading"
        >
          {{ loading ? "Iniciando..." : "Ver video" }}
        </button>
      </div>

      <div class="sourcePreviewPlayer" v-if="previewEventoId !== ''">
        <ViewEvento
          :key="previewEventoId"
          :evento-id="previewEventoId"
          :canal="0"
          :clean="true"
          :embedded="true"
          :prop-sofa-score="false"
          :preview="true"
        />
      </div>
    </div>
  </Dialog>
</template>

<script>
import { io } from "socket.io-client";
import util from "../includes/util.js";
import Dialog from "../components/Dialog.vue";
import ViewEvento from "../pages/ViewEvento.vue";

export default {
  name: "DialogSourceManager",
  components: { Dialog, ViewEvento },
  methods: {
    abrir(source, device, autoStart) {
      this.source = source || {};
      this.deviceId = "";
      this.audioId = "";
      this.previewEventoId = "";
      this.activePreviewCommandId = "";
      this.mensagem = "";
      this.loading = false;
      this.connected = false;
      this.autoStartPreview = autoStart == true;
      this.autoStartDispatched = false;

      if (device && device.id) {
        this.deviceId = device.id;
      } else if (this.videoDevices.length == 1) {
        this.deviceId = this.videoDevices[0].id;
      }
      this.aplicarAudioVinculado();

      this.mensagem = "Conectando...";
      this.$refs.dialog.abrir();
      this.conectarSocket();
    },
    fecharSocket() {
      if (this.socket) {
        try {
          this.socket.disconnect();
        } catch (e) {
          console.log(e);
        }
      }

      this.socket = null;
    },
    conectarSocket() {
      this.fecharSocket();

      const token = localStorage.getItem("ckd");
      this.socket = io(this.socketBaseUrl(), {
        auth: {
          role: "manager",
          token,
          sourceKey: this.source.key,
        },
        transports: ["websocket", "polling"],
      });

      this.socket.on("connect_error", (err) => {
        this.connected = false;
        this.mensagem = err.message;
      });

      this.socket.on("source:connection", (payload) => {
        this.connected = payload && payload.connected == true;
        if (!this.connected) {
          this.mensagem = "Source offline. Aguardando conexao...";
        } else {
          this.mensagem = "";
        }
        this.iniciarPreviewAutomatico();
      });

      this.socket.on("source:preview:status", (payload) => {
        this.onPreviewStatus(payload || {});
      });
    },
    socketBaseUrl() {
      var apiUrl = process.env.VUE_APP_URL_API || "";

      if (apiUrl.endsWith("/api")) {
        apiUrl = apiUrl.substring(0, apiUrl.length - 4);
      }

      return apiUrl;
    },
    iniciarPreview() {
      if (!this.socket || !this.connected || this.deviceId == "") {
        return;
      }

      const device = this.videoDevices.find((item) => item.id == this.deviceId);
      const audio = this.audioDevices.find((item) => item.id == this.audioId);
      const commandId = Date.now().toString();
      this.activePreviewCommandId = commandId;
      this.loading = true;
      this.mensagem = "Solicitando preview...";
      this.previewEventoId = "";

      this.socket.emit("source:preview:start", {
        commandId,
        sourceKey: this.source.key,
        deviceId: this.deviceId,
        deviceLabel: device ? device.label : this.deviceId,
        audioId: this.audioId,
        audioLabel: audio ? audio.label : this.audioId,
        servidor: process.env.VUE_APP_SERVIDOR_PADRAO,
      });
    },
    onAudioChange() {
      if (this.previewEventoId !== '' && this.socket && this.connected) {
        this.restartingAudio = true;
        this.activePreviewCommandId = '';
        this.loading = true;
        this.mensagem = "Trocando áudio...";
        this.socket.emit("source:preview:stop", {
          eventoId: this.previewEventoId,
          sourceKey: this.source.key,
        });
        this.previewEventoId = '';
      }
    },
    aplicarAudioVinculado() {
      const link = (this.source.deviceAudioLinks || []).find((item) => {
        return item.videoId == this.deviceId;
      });

      this.audioId = link ? link.audioId : "";
    },
    iniciarPreviewAutomatico() {
      if (
        !this.autoStartPreview ||
        this.autoStartDispatched ||
        !this.connected ||
        this.deviceId == ""
      ) {
        return;
      }

      this.autoStartDispatched = true;
      this.iniciarPreview();
    },
    async onPreviewStatus(payload) {
      if (
        payload.commandId &&
        this.activePreviewCommandId &&
        payload.commandId !== this.activePreviewCommandId
      ) {
        return;
      }

      if (payload.status === "stopped" && this.restartingAudio) {
        this.restartingAudio = false;
        this.iniciarPreview();
        return;
      }

      if (payload.status == "error") {
        this.loading = false;
        this.mensagem = payload.error || "Erro ao iniciar preview.";
        return;
      }

      if (payload.status == "received") {
        this.mensagem = "Comando recebido pelo source.";
      } else if (payload.status == "creating-event") {
        this.mensagem = "Preparando evento de preview.";
      } else if (payload.status == "starting-transmission") {
        this.mensagem = "Iniciando transmissao.";
      } else if (payload.status == "started") {
        this.loading = false;
        this.mensagem = payload.reused
          ? "Preview reutilizado."
          : "Preview iniciado.";
        this.previewEventoId = payload.eventoId;
      }
    },
  },
  beforeDestroy() {
    this.fecharSocket();
  },
  mounted() {
    this.uniqueid = "dialogSourceManager_" + util.guidGenerator();
  },
  computed: {
    videoDevices: function () {
      const devices = this.source.devices && this.source.devices.videos
        ? this.source.devices.videos
        : [];
      return devices.slice().sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
    audioDevices: function () {
      const devices = this.source.devices && this.source.devices.audios
        ? this.source.devices.audios
        : [];
      return devices.slice().sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
    selectableAudioDevices: function () {
      return this.audioDevices.filter((device) => device.id !== "none");
    },
  },
  data: function () {
    return {
      uniqueid: "",
      source: {},
      socket: null,
      connected: false,
      deviceId: "",
      audioId: "",
      loading: false,
      mensagem: "",
      previewEventoId: "",
      activePreviewCommandId: "",
      restartingAudio: false,
      autoStartPreview: false,
      autoStartDispatched: false,
    };
  },
};
</script>

<style>
.sourcePreviewPlayer {
  margin-top: 15px;
  background: #111111;
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}

.sourcePreviewPlayer video {
  width: 100%;
  height: auto;
  max-height: 270px;
  background: #111111;
  border: 0;
  display: block;
}
</style>
